var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#1840B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_7367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4961 18.0293H15.8398C14.856 18.0293 14.0586 18.8351 14.0586 19.8293V31.2293C14.0586 32.2235 14.856 33.0293 15.8398 33.0293H29.4961C30.4799 33.0293 31.2773 32.2235 31.2773 31.2293V19.8293C31.2773 18.8351 30.4793 18.0293 29.4961 18.0293Z",
    fill: "url(#paint0_linear_461_7367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3438 26.8004C18.9996 26.8004 19.5312 26.2631 19.5312 25.6004C19.5312 24.9376 18.9996 24.4004 18.3438 24.4004C17.6879 24.4004 17.1562 24.9376 17.1562 25.6004C17.1562 26.2631 17.6879 26.8004 18.3438 26.8004Z",
    fill: "#CCDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 26.8004C23.1558 26.8004 23.6875 26.2631 23.6875 25.6004C23.6875 24.9376 23.1558 24.4004 22.5 24.4004C21.8442 24.4004 21.3125 24.9376 21.3125 25.6004C21.3125 26.2631 21.8442 26.8004 22.5 26.8004Z",
    fill: "#CCDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6562 26.8004C27.3121 26.8004 27.8438 26.2631 27.8438 25.6004C27.8438 24.9376 27.3121 24.4004 26.6562 24.4004C26.0004 24.4004 25.4688 24.9376 25.4688 25.6004C25.4688 26.2631 26.0004 26.8004 26.6562 26.8004Z",
    fill: "#CCDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 18.1004C18.6406 18.1004 18.6406 16.9544 18.6406 14.8004C18.6406 12.6464 20.3684 10.9004 22.5 10.9004C24.6316 10.9004 26.3594 12.6464 26.3594 14.8004C26.3594 15.9884 26.3594 18.1004 26.3594 18.1004",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4115 33.0996H15.6719C14.688 33.0996 13.8906 32.2938 13.8906 31.2996V19.8996C13.8906 18.9054 14.688 18.0996 15.6719 18.0996H18.6406",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.499 18.0996H29.3277C30.3116 18.0996 31.109 18.9054 31.109 19.8996V31.2996C31.109 32.2938 30.3116 33.0996 29.3277 33.0996H26.3584",
    stroke: "white",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_7367",
    x1: 30.5,
    y1: 32.5,
    x2: 15.5,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.413896,
    stopColor: "#1840B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977452,
    stopColor: "#1840B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_7367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24,
    fill: "white",
    transform: "translate(13 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPassword);
export default __webpack_public_path__ + "static/media/loginPassword.6e8b9a7a811883cb642daaef7ab661ee.svg";
export { ForwardRef as ReactComponent };